/**
 * Notifications + Profile routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { InternalOnlyRoute } from '../InternalOnlyRoute';

// Profile pages
const ProfilePage = lazyWithRetry(() => import('@/features/profile/pages/ProfilePage'));

// Notifications pages
const NotificationsPage = lazyWithRetry(() => import('@/features/notifications/pages/NotificationsPage'));

// Neither of these pages sits behind a permission key today — every internal role is
// allowed its own profile/notifications, so PermissionRoute was never in the picture
// here. InternalOnlyRoute is what keeps a client session out (phase0-part2 §2.5).
//
// Since FE-F1 the parent `ProtectedLayout` is itself wrapped in `InternalOnlyRoute`, which
// is what actually keeps the internal shell from mounting (a guard on these elements fires
// INSIDE `AppLayout`). The element-level guards below are kept as defence in depth: they
// stay correct if either route is ever lifted out of `ProtectedLayout`, and re-checking
// costs one store read.
export const miscRoutes: RouteObject[] = [
      // --------------------------------
      // Notifications
      // --------------------------------
      {
        path: ROUTES.notifications.list,
        element: (
          <InternalOnlyRoute>
            <NotificationsPage />
          </InternalOnlyRoute>
        ),
      },

      // --------------------------------
      // Profile
      // --------------------------------
      {
        path: ROUTES.profile.view,
        element: (
          <InternalOnlyRoute>
            <ProfilePage />
          </InternalOnlyRoute>
        ),
      },
      {
        path: ROUTES.profile.edit,
        element: (
          <InternalOnlyRoute>
            <ProfilePage />
          </InternalOnlyRoute>
        ),
      },
      {
        path: ROUTES.profile.settings,
        element: (
          <InternalOnlyRoute>
            <ProfilePage />
          </InternalOnlyRoute>
        ),
      },
];
